import Select from 'react-select';

import { helpText, labelClasses } from './common';
import { getCountryRegions } from './CountrySelect';

const getCountryRegionsOptions = (country) =>
  getCountryRegions(country)
    .map(({ name }) => ({ value: name, label: name }));


const RegionSelect = ({ country, formik, onChange, schema }) => (
  <div className="field">
    <label className={labelClasses(schema, 'region')} htmlFor="region">Region</label>
    <Select
      isClearable={true}
      clearValue={() => ''}
      isDisabled={!country}
      id="region"
      instanceId="region"
      onChange={e => onChange(e?.value || '')}
      onBlur={formik.handleBlur}
      value={formik.values.region ? { value: formik.values.region, label: formik.values.region } : null}
      options={getCountryRegionsOptions(country)} />
    {helpText(formik, 'region')}
  </div>
);

const RegionSelectSimple = ({ country, onChange, placeholder, value }) => (
  <Select
    id="region"
    instanceId="region"
    isClearable={true}
    isDisabled={!country}
    onChange={value => onChange(value?.value)}
    value={value ? { value: value, label: value } : null}
    placeholder={placeholder}
    options={getCountryRegionsOptions(country)} />
)

export default RegionSelect;

export {
  RegionSelectSimple
};
